import { AccidentAtlasApiResponse } from '@components/accidentAtlas/types/api'

const DEFAULT_API_URL = '/data/accident-atlas/output.json'
const LIVE_CENSUS_URL = '/census/output.json'

export function getAccidentAtlasApiUrl(): string {
  return process.env.GATSBY_ACCIDENT_ATLAS_API_URL || DEFAULT_API_URL
}

export async function fetchAccidentAtlasData(
  options: RequestInit = {}
): Promise<AccidentAtlasApiResponse> {
  const url = getAccidentAtlasApiUrl()
  const response = await fetch(url, {
    // Re-fetch live census data; ConfigMap updates propagate without pod restart.
    ...(url === LIVE_CENSUS_URL ? { cache: 'no-store' as RequestCache } : {}),
    ...options,
  })

  if (!response.ok) {
    throw new Error(
      `Accident Atlas API failed: ${response.status} ${response.statusText}`
    )
  }

  return (await response.json()) as AccidentAtlasApiResponse
}
